import "./Button.scss";
import block from "bem-cn";
import { Link, useHistory } from "react-router-dom";

const b = block("Button");

type Props = {
  type?: "button" | "submit" | "reset";
  text?: string;
  addOnClick?: Function;
  width100?: boolean;
  height100?: boolean;
  padding0?: boolean;
  paddingLR0?: boolean;
  paddingTB0?: boolean;
  link?: string;
  hasBorder?: boolean;
};

const Button = ({
  type = "button",
  text = "text",
  addOnClick,
  width100 = false,
  height100 = false,
  padding0 = false,
  paddingLR0 = false,
  paddingTB0 = false,
  link = "",
  hasBorder = false,
}: Props) => {
  const history = useHistory();

  const handleOnClickButton = (e: any) => {
    if (e.target === e.currentTarget && link.length) {
      history.push(link);
    }
    addOnClick && addOnClick();
  };

  return (
    <button
      type={type}
      className={b({
        width100,
        height100,
        padding0,
        paddingLR0,
        paddingTB0,
        hasBorder,
      })}
      onClick={handleOnClickButton}
    >
      {link ? (
        <Link className={b("link")} to={link}>
          {text}
        </Link>
      ) : (
        text
      )}
    </button>
  );
};

export default Button;
